import { MapPin, Wifi } from "lucide-react";
import { ADDRESS } from "../../lib/site";

export const Modalities = () => {
    return (
        <section id="atendimento" data-testid="modalities-section" className="py-24 lg:py-32 bg-[#F5F4F2]">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="max-w-2xl mb-16 reveal">
                    <p className="overline mb-5">Atendimento</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.08] text-[#2F2F2F]">
                        Online ou presencial —
                        <span className="italic text-[#9f1e1e]"> do jeito que faz sentido para você.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-[#B7A6B0]/30 border border-[#B7A6B0]/30">
                    <Card
                        icon={<MapPin className="w-6 h-6" strokeWidth={1.2} />}
                        eyebrow="Presencial"
                        title="Brasília — Asa Sul"
                        body="Um espaço acolhedor, reservado e pensado para que o processo terapêutico aconteça em segurança. Ideal para quem busca um ritual semanal de cuidado fora de casa."
                        meta={ADDRESS}
                        testId="modality-presencial"
                    />
                    <Card
                        icon={<Wifi className="w-6 h-6" strokeWidth={1.2} />}
                        eyebrow="Online"
                        title="De qualquer lugar do Brasil"
                        body="Sessões por videochamada com a mesma profundidade do atendimento presencial. Para quem viaja, mora longe ou prefere a continuidade do cuidado a partir de casa."
                        meta="Plataforma segura · Brasil e exterior"
                        testId="modality-online"
                    />
                </div>
            </div>
        </section>
    );
};

const Card = ({ icon, eyebrow, title, body, meta, testId }) => (
    <div data-testid={testId} className="bg-[#F5F4F2] p-10 lg:p-14 reveal">
        <div className="flex items-center gap-4 mb-8 text-[#9f1e1e]">
            {icon}
            <span className="overline">{eyebrow}</span>
        </div>
        <h3 className="font-display text-3xl lg:text-[2.25rem] leading-tight text-[#2F2F2F] mb-5">{title}</h3>
        <p className="text-[15px] leading-relaxed text-[#2F2F2F]/75 mb-8 max-w-md">{body}</p>
        <div className="pt-6 border-t border-[#B7A6B0]/50">
            <p className="text-xs uppercase tracking-[0.2em] text-[#2F2F2F]/55 mb-2">Endereço / Disponibilidade</p>
            <p className="text-sm text-[#2F2F2F]/85">{meta}</p>
        </div>
    </div>
);
